import { useState, useEffect, useRef } from "react";
import ClientsToolbar from "./ClientsToolbar";
import ClientsTable from "./ClientsTable";
import Pagination from "../components/Pagination";
import OtpInput from "react-otp-input";
import otp_icon from "../../images/otp.svg";
import { formatTimeMinutes } from "../../components/CommonFunction/CommonFunction";
import api, { BASE_URL } from "../../../src/api_interceptor/api";
import Loader from "../../components/loader/Loader";
import CaptchaSection from "../../components/captcha/captcha";
import { useNavigate, useLocation } from "react-router-dom";
import { get } from "jquery";
import GenericModal from "../components/GenericModal";

const Clients = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const hasFetched = useRef(false);
  const [searchClient, setSearchClient] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [pendingClientId, setPendingClientId] = useState(null);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [editErrorOpen, setEditErrorOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageLength] = useState(10);
  const navigate = useNavigate();

  // const [clients, setClients] = useState([
  //   {
  //     id: "CD101",
  //     name: "GlobalTech Solutions International Pvt Ltd Bangalore India",
  //     createdOn: "2024-02-03",
  //     licenses: 13,
  //     startDate: "2024-03-01",
  //     endDate: "2026-03-01",
  //     status: "Active",
  //   },
  //   {
  //     id: "CD102",
  //     name: "Innova Software Services Pvt Ltd",
  //     createdOn: "2024-01-15",
  //     licenses: 8,
  //     startDate: "2024-02-01",
  //     endDate: "2026-02-01",
  //     status: "Active",
  //   },
  //   {
  //     id: "CD103",
  //     name: "NextGen AI Research & Development Labs Hyderabad",
  //     createdOn: "2023-12-10",
  //     licenses: 20,
  //     startDate: "2024-01-01",
  //     endDate: "2025-12-31",
  //     status: "Inactive",
  //   },
  //   {
  //     id: "CD104",
  //     name: "Apex Digital Consulting Pvt Ltd Mumbai",
  //     createdOn: "2024-03-12",
  //     licenses: 15,
  //     startDate: "2024-04-01",
  //     endDate: "2026-04-01",
  //     status: "Active",
  //   },
  //   {
  //     id: "CD105",
  //     name: "BlueWave Technologies India Pvt Ltd Chennai",
  //     createdOn: "2024-02-20",
  //     licenses: 5,
  //     startDate: "2024-03-15",
  //     endDate: "2025-03-14",
  //     status: "Active",
  //   },
  //   {
  //     id: "CD106",
  //     name: "Nimbus Cloud Solutions Pvt Ltd Pune",
  //     createdOn: "2023-11-05",
  //     licenses: 12,
  //     startDate: "2023-12-01",
  //     endDate: "2025-12-01",
  //     status: "Inactive",
  //   },
  //   {
  //     id: "CD107",
  //     name: "Vertex FinTech Innovations Pvt Ltd Gurugram",
  //     createdOn: "2024-04-08",
  //     licenses: 25,
  //     startDate: "2024-05-01",
  //     endDate: "2027-05-01",
  //     status: "Active",
  //   },
  //   {
  //     id: "CD108",
  //     name: "Quantum HealthCare Systems Pvt Ltd Kochi",
  //     createdOn: "2024-01-28",
  //     licenses: 9,
  //     startDate: "2024-02-10",
  //     endDate: "2026-02-09",
  //     status: "Active",
  //   },
  //   {
  //     id: "CD109",
  //     name: "Orbit E-Commerce Platforms Pvt Ltd Noida",
  //     createdOn: "2023-10-18",
  //     licenses: 18,
  //     startDate: "2023-11-01",
  //     endDate: "2025-11-01",
  //     status: "Inactive",
  //   },
  //   {
  //     id: "CD110",
  //     name: "Synergy Data Analytics Pvt Ltd Kolkata",
  //     createdOn: "2024-03-25",
  //     licenses: 7,
  //     startDate: "2024-04-01",
  //     endDate: "2026-04-01",
  //     status: "Active",
  //   },
  // ]);

  // const handleToggleStatus = (id, currentStatusCode) => {
  //   setModalOpen(true);

  //   const newStatusCode = currentStatusCode === true ? false : true;
  //   updateClientStatus(id, newStatusCode);
  // };


  const [modalState, setModalState] = useState({
  open: false,
  title: "",
  description: "",
  type: "success", // success | error | warning
  });
  const handleToggleStatus = (id, currentStatusCode) => {
    
    setPendingClientId(id);
    // setPendingStatus(!currentStatusCode); // true ↔ false

    const newStatusCode = currentStatusCode === 1 ? 2 : 1;
    setPendingStatus(newStatusCode);
    setModalOpen(true);
  };

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    getClientList();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      setCurrentPage(1);
      getClientList();
    }, 400); // debounce

    return () => clearTimeout(delay);
  }, [searchClient]);

  useEffect(() => {
    if (hasFetched.current) {
      getClientList();
    }
  }, [currentPage]);

  const showSuccess = (message) => {
  setModalState({
    open: true,
    title: "Success",
    description: message,
    type: "success",
  });
};

const showError = (message) => {
  setModalState({
    open: true,
    title: "Error",
    description: message || "Something went wrong. Please try again.",
    type: "error",
  });
};

const showWarning = (message) => {
  setModalState({
    open: true,
    title: "Action Not Allowed",
    description: message,
    type: "warning",
  });
};


  const getClientList = () => {
    setIsLoading(true);
    const API_URL = "api/GetAllClientList";
    const req_body = {
      filter: searchClient,
      pageIndex: currentPage,
      totalPage: totalPages,
      pageLength: pageLength,
      errorMessage: "",
      Type: "Client",
      SortAction: "None",
    };

    api
      .post(API_URL, req_body, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      .then((response) => {
        setIsLoading(false);
        if (response && response.data) {
          // Check if AllClientList exists first - if data exists, treat as success
          // This prioritizes data existence over errorMessage check
          if (response.data.AllClientList !== undefined && response.data.AllClientList !== null) {
            setClients(response.data.AllClientList);
            setTotalPages(response.data.totalPage || 1);
          } else if (response.data.errorMessage && response.data.errorMessage.toLowerCase() !== "success") {
            // Only show error if errorMessage exists and is not "Success" (case-insensitive)
            const errorMsg = response.data.errorMessage === "Exception" 
              ? "An error occurred while loading client list. Please try again." 
              : response.data.errorMessage || "Failed to load client list.";
            showError(errorMsg);
          } else {
            // No data and no explicit error message - set empty array (silent success)
            setClients([]);
          }
        } else {
          showError("Invalid response from server. Please try again.");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Get client list error:", error);
        
        if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
          showError("Unable to connect to server. Please check your internet connection.");
        } else if (error.response) {
          const errorMsg = error.response.data?.Message || "Failed to load client list. Please try again.";
          showError(errorMsg);
        } else {
          showError("An unexpected error occurred. Please try again.");
        }
      });
  };
  const handleEditClient = (client) => {
  if (client.StatusCodeId !== 1) {
    showWarning("Please activate the client before editing.");
    return;
  }

  navigate(`/clients/edit/${client.CompanyId}`);
};

  const updateClientStatus = (id, newStatusCode) => {
    setIsLoading(true);
    const API_URL = "api/UpdateClientStatus";
    // API expects isActivated (bool) and Id (int)
    // Note: Backend toggles the status regardless of isActivated value, but we send it to match API contract
    const req_body = {
      Id: id,
      isActivated: newStatusCode === 1, // true for activate (status 1), false for deactivate (status 2)
    };

    // Determine action text for success message based on intended new status
    const actionText = newStatusCode === 1 ? "activated" : "deactivated";

    api
      .post(API_URL, req_body, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      .then((response) => {
        setIsLoading(false);
        
        // API returns integer directly (1 or 2) representing the new StatusCodeId
        // 1 = Activated, 2 = Deactivated
        if (response && response.data !== undefined && response.data !== null) {
          const returnedStatusCode = response.data;
          
          // Check if returned status code is valid (1 or 2)
          if (returnedStatusCode === 1 || returnedStatusCode === 2) {
            setModalOpen(false);
            // Determine actual action based on returned status
            const actualActionText = returnedStatusCode === 1 ? "activated" : "deactivated";
            showSuccess(`Client ${actualActionText} successfully.`);
            // List will refresh when user clicks OK on success modal
          } else if (returnedStatusCode === 0) {
            // API returned 0 indicating an error occurred
            showError("Failed to update client status. Please try again.");
            setModalOpen(false);
          } else {
            showError("Invalid response from server. Please try again.");
            setModalOpen(false);
          }
        } else {
          showError("Invalid response from server. Please try again.");
          setModalOpen(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setModalOpen(false);
        console.error("Update client status error:", error);

        if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
          showError("Unable to connect to server. Please check your internet connection.");
        } else if (error.response) {
          // Server responded with error status (e.g., BadRequest - 400)
          if (error.response.status === 400) {
            showError("Failed to update client status. Please try again.");
          } else {
            const errorMsg = error.response.data?.Message || `Failed to ${actionText} client. Please try again.`;
            showError(errorMsg);
          }
        } else {
          showError("An unexpected error occurred. Please try again.");
        }
      });
  };

  const openStatusModal = (client) => {
    setSelectedClient(client);
    setModalOpen(true);
  };

  return (
    <>
          {isLoading && <Loader />}
    
    <div className="bg-white p-4 rounded-lg flex flex-col h-full min-h-0">
      <div className="mb-4">
        <h1 className="text-2xl font-semibold leading-[1.3]">Clients</h1>
        <p className="text-base text-primary">Clients</p>
      </div>

      <ClientsToolbar setSearchClient={setSearchClient} />
      {/* <ClientsTable data={clients} onToggleStatus={handleToggleStatus} /> */}
      <div className="flex-1 min-h-0">
      <ClientsTable
  data={clients}
  onToggleStatus={handleToggleStatus}
  onEditClient={handleEditClient}
/>
 </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalRecords={clients.length}
        onPageChange={(newPage) => {
          setCurrentPage(newPage);
        }}
      />

      <GenericModal
        open={modalOpen}
        title="Confirm Action"
        description={`Are you sure you want to ${
         pendingStatus === 1 ? "activate" : "deactivate"
        } this client?`}
        primaryText="Yes"
        secondaryText="No"
        loading={isLoading}
        onPrimary={() => {
          updateClientStatus(pendingClientId, pendingStatus);
        }}
        onClose={() => {
          setModalOpen(false);
          setPendingClientId(null);
          setPendingStatus(null);
        }}
      />

      {/* <GenericModal
        open={successModalOpen}
        title="Success"
        description={successMessage}
        primaryText="OK"
        onPrimary={() => setSuccessModalOpen(false)}
        onClose={() => setSuccessModalOpen(false)}
      /> */}
      <GenericModal
        open={modalState.open}
        title={modalState.title}
        description={modalState.description}
        type={modalState.type}
        primaryText="OK"
        onPrimary={() => {
          const wasSuccess = modalState.type === "success";
          setModalState((prev) => ({ ...prev, open: false }));
          if (wasSuccess) {
            getClientList();
          }
        }}
        onClose={() => {
          const wasSuccess = modalState.type === "success";
          setModalState((prev) => ({ ...prev, open: false }));
          if (wasSuccess) {
            getClientList();
          }
        }}
      />


    </div>
    </>
  );
};

export default Clients;
